<template>
  <section class="section-pay w-full min-h-607 pt-120 bg-[#f7f7f7] text-center">
    <div class="w-full max-w-[1600px] mx-auto px-140">
      <div class="text-4xl font-bold mb-20 w-full" v-html="$t('lang.cost1')"></div>

      <div class="w-full font-[500]" style="font-size: 22px;">
        <span class="text-[#FF7800]">{{ $t('lang.cost2') }}</span>
        {{ $t('lang.cost3') }}
      </div>

      <div class="w-full text-1xl text-black mt-50">{{ $t('lang.cost4') }}</div>

      <img src="../assets/home_19.png" alt="changjing" class="w-1650 h-580 relative top-[90px] object-scale-down" />
    </div>
  </section>
</template>

<script>
export default {
  name: "sectionPay",

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>